import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { FixedExpensesForm } from '@/components/forms/FixedExpensesForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateFixedExpensesPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/rates-and-expenses/fixed-expenses')
  }

  const handleCancel = () => {
    navigate('/rates-and-expenses/fixed-expenses')
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Create Fixed Expenses
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Add a new Fixed Expense
            </Text>
          </CardHeader>
          <CardBody>
            <FixedExpensesForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


